import { css } from '@emotion/react';
import config from '$/config';
import isMobile from '$/utils/isMobile';
import React from 'react';
import { theme } from 'twin.macro';
import Logo from '../Logo';
import { MediaRefFragment } from '$/GraphQL/schema/types';
import { cssDimensionsForRef } from '$/utils/image';
import { useImageSrcFromRef } from '$/hooks/useImageSrcFromRef';

interface TeamHeaderProps {
  className?: string;
  logoMediaRef?: MediaRefFragment | null;
  wide?: boolean;
}

export const TeamHeader: React.FC<TeamHeaderProps> = ({ wide, logoMediaRef, className }) => {
  const logoMediaUrl = useImageSrcFromRef(logoMediaRef, {
    w: config.LOGO_MAX_WIDTH,
    h: config.LOGO_MAX_HEIGHT,
  });
  return (
    <div
      className={`public-list__header border-b bg-white ${className ?? ''}`}
      css={css`
        border-bottom: 1px solid ${theme`colors.analytics.gray`.toString()};
      `}
    >
      <div
        className={`${
          wide ? 'wide-container' : 'container mx-auto'
        } flex flex-row py-6 md:px-0 px-1_5e justify-between items-center`}
      >
        {logoMediaRef && (
          <img
            src={logoMediaUrl}
            alt='logo'
            className='mr-2'
            css={css`
              ${cssDimensionsForRef(logoMediaRef, {
                maxWidth: config.LOGO_MAX_WIDTH,
                maxHeight: config.LOGO_MAX_HEIGHT,
              })}
            `}
          />
        )}
        {!logoMediaRef && (
          <Logo heightPx={24} className='mr-2' version={isMobile ? 'icon' : 'normal'} />
        )}
      </div>
    </div>
  );
};
